module.exports = __webpack_public_path__ + "img/us_4.30c6299e.jpg";